// extracted by mini-css-extract-plugin
module.exports = {"frame":"public-hero_frame__wP1kR","content":"public-hero_content__avEpB","backdrop":"public-hero_backdrop__Ek3Di","overlay":"public-hero_overlay__W6LbW"};